// SafeImage.tsx
import React from 'react';
import { Image, Text, View } from '@react-pdf/renderer';

interface SafeImageProps {
  src?: any;
  style?: any;
  alt?: string;
  debugLabel?: string;
}

export const SafeImage: React.FC<SafeImageProps> = ({
  src,
  style,
  alt = '',
  debugLabel,
}) => {
  const normalizeSrc = (s: any): string | undefined => {
    if (!s) return undefined;
    if (typeof s === 'string') return s;
    if (typeof s === 'object' && 'src' in s) return s.src;
    return undefined;
  };

  const safeSrc = normalizeSrc(src);

  if (!safeSrc) {
    console.warn(
      `⚠️ SafeImage: Missing or invalid src in ${debugLabel || alt}`
    );

    return (
      <View
        style={[
          {
            backgroundColor: '#eee',
            alignItems: 'center',
            justifyContent: 'center',
          },
          style,
        ]}
      >
        <Text style={{ fontSize: 8, color: '#666' }}>
          {alt || 'missing image'}
        </Text>
      </View>
    );
  }

  return <Image src={safeSrc} style={style} />;
};
